export default {
  title: "Búsqueda Rápida CBAM",
  subtitle: {
    noReg: "No se requiere registro",
    free: "Gratis",
    minutes: "1 minuto",
  },
  steps: {
    country: "País",
    product: "Producto",
    volume: "Volumen de importación",
    result: "Resultado",
  },
  step1: {
    title: "¿Está importando desde fuera de la UE a la UE, o comerciando dentro de la UE?",
    outsideEU: "Importar desde fuera de la UE",
    insideEU: "Dentro de la UE (exento)",
  },
  step2: {
    title: "¿Principales productos importados? (Soporte multi-selección)",
    steel: "Acero",
    aluminum: "Aluminio",
    cement: "Cemento",
    fertilizer: "Fertilizante",
    electricity: "Electricidad",
    hydrogen: "Hidrógeno",
    other: "Otro",
  },
  step3: {
    title: "¿Volumen estimado de importación a la UE en 2026?",
    lt50t: "< 50 toneladas (exento)",
    between50_500t: "50–500 toneladas",
    gt500t: "> 500 toneladas",
  },
  result: {
    lowRisk: "Bajo riesgo",
    mediumRisk: "Riesgo medio",
    highRisk: "Alto riesgo",
    insideEU:
      "¡Felicidades! El comercio interno de la UE está exento, no se requiere notificación/pago. Pero recomendamos monitorear los cambios.",
    outsideEU:
      "¡Felicidades! Volumen anual < 50 toneladas exento o productos no cubiertos, no se requiere notificación/pago. Pero recomendamos monitorear los cambios.",
    highRiskDesc:
      "Debe reportar + comprar certificados (basados en emisiones), error > 10% resulta en multa de €1K–€10K.",
    mediumRiskDesc:
      "Reporte trimestral requerido, posiblemente pago desde 2026. Recomendamos generar informe en formato PwC para mitigar riesgos.",
  },
  whyChoose: {
    title: "¿Por qué elegir TaxEcoBit?",
    description:
      "TaxEcoBit le ayuda a calcular con 90%+ de precisión, PDF/Excel conforme en 3 segundos.",
    features: {
      accurate: "Cumplimiento preciso: Error <10%, cumple con los requisitos CBAM",
      fast: "Informe rápido: 3 segundos para generar PDF/Excel conforme",
      cost: "Ventaja de costo: €99/mes, muy por debajo de competidores €500+/mes",
      trial: "Prueba gratuita por 14 días, experimente todas las funciones premium",
    },
  },
  newRule:
    "Nueva regulación en 2026: Anual < 50 toneladas exento (excepto hidrógeno/electricidad), pero los informes aún necesitan precisión para evitar multas.",
  buttons: {
    prev: "Anterior",
    next: "Siguiente",
    viewResult: "Ver Resultado",
    generateReport: "Generar Informe Completo (Registro/prueba gratuita)",
    restart: "Reiniciar",
  },
};
